module.exports = __webpack_public_path__ + "img/course_header.adc2d916.png";